const forbes = {

	$html = null,
	$body = null,
	vpWidth: null,
	breakpoints: null,
	is_mobile: null,

	init: function(){
		this.elements();
		this.resize();
		this.menu.init();
	},

	viewport: function() {
		const e = window,
		a = 'inner';
		if (!('innerWidth' in window)) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width: e[a + 'Width'], height: e[a + 'Height'] };
	},

	elements: function(){
		this.$html = $('html');
		this.$html.removeClass('no-js');
		this.$body = $('body');
		this.breakpoints = 
		{
			xxl: 1440,
			xl: 1200,
			lg: 992,
			md: 768,
			sm: 576
		};
		this.is_mobile =(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
			? true : false;
	},
	
	resize: function(){
		const _this = this;
		forbes.vpWidth = forbes.viewport().width;
		$(window).on('resize', function() {
			forbes.vpWidth = forbes.viewport().width;
			forbes.is_mobile =(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
				? true : false;
		});
	},

	menu:
	{
		$el: null,
		$btn: null,
		$header: null,

		init: function(){
			this.set_elements();
			this.bind_menu();
		},

		set_elements: function(){
			this.$el = $('#nav-menu');
			this.$btn = $('input#menu-button');
			this.$header = $('.site-header');
		},

		bind_menu: function(){
			const _this = this;
			this.$btn.on('click', function(e){
				let space = (forbes.vpWidth >= forbes.breakpoints.lg)
					? 60 : 30;
				let space15 = (forbes.is_mobile) ? 0 : 15;
				if(_this.$btn.is(':checked')){
					_this.$el.addClass('opened');
					forbes.$body.css({
						overflow: 'hidden',
						paddingRight: space15+'px'
					});
					_this.$header
						.css('width', 'calc(100% - '+space15+'px)');
				} else {
					_this.$el.removeClass('opened');
					forbes.$body.css({
						overflow: 'initial',
						paddingRight: '0'
					});
					_this.$header
						.css('width', '100%');
				}
			});
		},
	},

	modal_youtube: {

		$mod: null,
		$modal: null,

		init: function(){
			this.elements();
			if(this.$mod.length){
				this.bind();
			}
		},

		elements: function(){
			this.$mod = $('.mod-videos');
			this.$modal = $('#modal-youtube');
		},

		bind: function(){
			this.$mod.find('.open-modal').on('click', this.open.bind(this));
			this.$mod.find('.close-modal').on('click', this.close.bind(this));
			this.$modal.on('click', this.close.bind(this));
		},

		open: function(e){
			e.preventDefault();
			let elem = $(e.currentTarget);
			let url = $(elem).data('url');
			this.$modal.find('.content').html('<iframe type="text/html" width="640" height="360" src="https://www.youtube.com/embed/'+url+'" frameborder="0"></iframe>');
			this.$modal.show();
			$(document).on('keydown.modalEsc', (e) => {
    		if (e.key === 'Escape') this.close();
  		});
		},

		close: function(e){
			this.$modal.find('.content').html('').end().hide();
			$(document).off('keydown.modalEsc');
		}	

	}
}

const $ = jQuery.noConflict();
$(document).ready(function() {
	forbes.init();
});
